import MicroModal from 'micromodal';
import $ from 'jquery';

(function (Modal) {
  App.registerBehavior('Modal', function registerModalBehavior() {
    $('[data-modal]').once('ModalBehavior').each(function () {
      MicroModal.init();
      // The triggering HTML element
      const $trigger = $(this);
      $trigger.on('click', function (e) {
        const action = 'string' === typeof $trigger.data('modal') && $trigger.data('modal') || 'open';
        const id = 'string' === typeof $trigger.data('modal-id') && $trigger.data('modal-id') || 'modal-default';
        const $modal = $('#' + id);
        const modalTitle = $trigger.data('modal-title') || '';
        let modal;
        e.preventDefault();
        if ('open' === action) {
          // Populate the modal
          if (0 < $modal.length) {
            modal = new Modal($modal);
            // Avoid override with empty title
            if (modalTitle) {
              modal.setTitle(modalTitle);
            }
            // Finally, open the modal
            modal.open();
          }
        }
      });
    });
  });
})(App.modal);